import "react-phone-input-2/lib/style.css"
import PhoneInput from "react-phone-input-2"
import { Box, HStack, Stack } from "@chakra-ui/react"
import { Input, Text } from "./"

interface TextFieldProps {
  label: string
  placeholder?: string
  value: string
  type?: string
  required?: boolean
  name?: string
  autoComplete?: string
  /** Helper text under the field. Hidden while `error` is set. */
  hint?: string
  /** Inline validation message; also turns the border red and sets aria-invalid. */
  error?: string
  disabled?: boolean
  inputMode?: "text" | "numeric" | "decimal" | "tel" | "email" | "url" | "search"
  onPaste?: (e: React.ClipboardEvent<HTMLInputElement>) => void
  onBlur?: () => void
  onChange: (v: string) => void
  /** Called with the country name when the phone input's country changes. Only fires for type="phone". */
  onPhoneCountryChange?: (countryName: string) => void
}

export const TextField = ({ label, placeholder, type, value, required, name, autoComplete, hint, error, disabled, inputMode, onPaste, onBlur, onChange, onPhoneCountryChange }: TextFieldProps) => {
  const formatSSN = (input: string) => {
    // Remove all non-digits
    const digits = input.replace(/\D/g, "")
    // Apply formatting
    const part1 = digits.slice(0, 3)
    const part2 = digits.slice(3, 5)
    const part3 = digits.slice(5, 9)

    let formatted = part1
    if (part2) formatted += `-${part2}`
    if (part3) formatted += `-${part3}`

    return formatted
  }
 
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputVal = e.target.value
    if (type === "ssn") {
      onChange(formatSSN(inputVal))
    } else {
      onChange(inputVal)
    }
  }

  return (
    <Stack w="100%">
      <HStack gap={1}>
        <Text fontSize="sm" fontWeight="bold">{label}</Text>
        {required && (
          <Box
            w="6px"
            h="6px"
            bg="red.500"
            borderRadius="full"
            mt="2px"
          />
        )}
      </HStack>
      {
        type === "phone" ? (
          <PhoneInput
            country={"us"}
            value={value}
            onChange={(value, country: { name?: string }) => {
              onChange(value)
              if (onPhoneCountryChange && country?.name) {
                onPhoneCountryChange(country.name)
              }
            }}
            inputProps={{
              name: name ?? "phone",
              required: true,
              autoComplete: autoComplete ?? "tel",
            }}
            inputStyle={{
              fontFamily: "Nunito Sans"
            }}
          />
        ) : (
          <Input
            placeholder={placeholder}
            type={type}
            value={value}
            name={name}
            autoComplete={autoComplete}
            inputMode={inputMode}
            aria-invalid={error ? true : undefined}
            borderColor={error ? "red.500" : undefined}
            disabled={disabled}
            opacity={disabled ? 0.7 : undefined}
            onPaste={onPaste}
            onBlur={onBlur}
            onChange={handleChange}
            required={required}
          />
        )
      }
      {error ? (
        <Text fontSize="xs" color="red.600">{error}</Text>
      ) : hint ? (
        <Text fontSize="xs" color="gray.500">{hint}</Text>
      ) : null}
    </Stack>
  )
}